import React from 'react';
import InfoContent from './info';
import DescriptionContent from './description';
import HostContent from './host';
import ScheduleContent from './schedule';

export default [
  <InfoContent />, <DescriptionContent />, <HostContent />, <ScheduleContent />
];
